/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CurrencyEnum } from '@spectrocoin/sc-currencies';

type FooterState = {
	buyCurrency: CurrencyEnum;
	link: { src: string; label: string } | null;
};

const initialState: FooterState = {
	buyCurrency: CurrencyEnum.BTC,
	link: null,
};

const slice = createSlice({
	initialState,
	name: 'footer',
	reducers: {
		setBuyCurrency: (state, { payload }: PayloadAction<CurrencyEnum>) => {
			state.buyCurrency = payload;
		},
		setLink: (state, { payload }: PayloadAction<{ src: string; label: string } | null>) => {
			state.link = payload;
		},
	},
});

export default slice;
